import axios from 'axios';

export const fetchCepAddress = async (cep: string) => {
    const cleaned = cep.replace(/\D/g, '');
    
    const res = await axios.get(`https://viacep.com.br/ws/${cleaned}/json/`);

    if (res.data.erro) {
        throw new Error('CEP não encontrado');
    }

    return {
        street: res.data.logradouro || '',
        district: res.data.bairro || '',
        city: res.data.localidade || '',
        state: res.data.estado || ''
    };
};

